/**
 * Client-side reinforcement when B2B price/cart restriction applies.
 * Relies on window.themeVariables.settings.b2bCommerceAllowed (false = block product-form submits and primary ATC targets).
 */
(function () {
  function gateActive() {
    var s = window.themeVariables && window.themeVariables.settings;
    return s && s.b2bCommerceAllowed === false;
  }

  if (!gateActive()) return;

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('is') !== 'product-form') return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );

  function disableAtcNodes() {
    document.querySelectorAll('[data-add-to-cart], [short-add-to-cart-btn]').forEach(function (el) {
      el.setAttribute('disabled', '');
      el.setAttribute('aria-disabled', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableAtcNodes);
  } else {
    disableAtcNodes();
  }

  document.addEventListener('shopify:section:load', disableAtcNodes);

  /**
   * product-item-meta link-wrapper (and similar) capture clicks before inner links.
   * Run in capture phase on document so login wins over the card wrapper.
   */
  function b2bNavigateLogin(e) {
    var el = e.target;
    if (el.nodeType !== 1) el = el.parentElement;
    if (!el || !el.closest) return;
    var node = el.closest('.b2b-commerce-login-link');
    if (!node) return;
    var href = node.getAttribute('data-login-href');
    if (!href && node.tagName === 'A') href = node.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    window.location.href = href;
  }

  document.addEventListener('click', b2bNavigateLogin, true);
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      b2bNavigateLogin(e);
    },
    true
  );
})();
